/**
 * TrustedHtml — single React escape hatch for audited HTML strings.
 *
 * SPDX-License-Identifier: LicenseRef-Proprietary
 * Copyright (c) 2026 Invariant Holdings LLC
 */

import React from "react";
import type { TrustedHtmlValue } from "../security/trustedHtml.js";

export interface TrustedHtmlProps extends Omit<React.HTMLAttributes<HTMLElement>, "children"> {
  readonly html: TrustedHtmlValue;
  readonly element?: "div" | "span";
}

export function TrustedHtml({
  html,
  element = "div",
  ...props
}: TrustedHtmlProps): React.JSX.Element {
  const Element = element;
  return (
    <Element
      {...props}
      data-csk-trusted-html={html.source}
      dangerouslySetInnerHTML={{ __html: html.__html }}
    />
  );
}
